import type { TMove } from 'constants/types';

const MOVES: TMove[] = [
  {
    id: 1,
    name: 'Pound',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '35',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 2,
    name: 'Karate Chop',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '25',
    power: '50',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 3,
    name: 'Double Slap',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '15',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 4,
    name: 'Comet Punch',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '18',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 5,
    name: 'Mega Punch',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '80',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 6,
    name: 'Pay Day',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 7,
    name: 'Fire Punch',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 8,
    name: 'Ice Punch',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 9,
    name: 'Thunder Punch',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 10,
    name: 'Scratch',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '35',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 11,
    name: 'Vice Grip',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '30',
    power: '55',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 12,
    name: 'Guillotine',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '30%',
    gen: 1,
  },
  {
    id: 13,
    name: 'Razor Wind',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 14,
    name: 'Swords Dance',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 15,
    name: 'Cut',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '30',
    power: '50',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 16,
    name: 'Gust',
    type: 'FLYING',
    category: 'Special',
    contest: 'Clever',
    pp: '35',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 17,
    name: 'Wing Attack',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '35',
    power: '60',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 18,
    name: 'Whirlwind',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 19,
    name: 'Fly',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '90',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 20,
    name: 'Bind',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '15',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 21,
    name: 'Slam',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '80',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 22,
    name: 'Vine Whip',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Cool',
    pp: '25',
    power: '45',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 23,
    name: 'Stomp',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 24,
    name: 'Double Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '30',
    power: '30',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 25,
    name: 'Mega Kick',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '120',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 26,
    name: 'Jump Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '100',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 27,
    name: 'Rolling Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '60',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 28,
    name: 'Sand Attack',
    type: 'GROUND',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 29,
    name: 'Headbutt',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '70',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 30,
    name: 'Horn Attack',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '25',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 31,
    name: 'Fury Attack',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '15',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 32,
    name: 'Horn Drill',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '30%',
    gen: 1,
  },
  {
    id: 33,
    name: 'Tackle',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '35',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 34,
    name: 'Body Slam',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '85',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 35,
    name: 'Wrap',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '15',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 36,
    name: 'Take Down',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '90',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 37,
    name: 'Thrash',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 38,
    name: 'Double-Edge',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 39,
    name: 'Tail Whip',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 40,
    name: 'Poison Sting',
    type: 'POISON',
    category: 'Physical',
    contest: 'Clever',
    pp: '35',
    power: '15',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 41,
    name: 'Twineedle',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '25',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 42,
    name: 'Pin Missile',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '25',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 43,
    name: 'Leer',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cool',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 44,
    name: 'Bite',
    type: 'DARK',
    category: 'Physical',
    contest: 'Tough',
    pp: '25',
    power: '60',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 45,
    name: 'Growl',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 46,
    name: 'Roar',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 47,
    name: 'Sing',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '55%',
    gen: 1,
  },
  {
    id: 48,
    name: 'Supersonic',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '55%',
    gen: 1,
  },
  {
    id: 49,
    name: 'Sonic Boom',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 50,
    name: 'Disable',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 51,
    name: 'Acid',
    type: 'POISON',
    category: 'Special',
    contest: 'Clever',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 52,
    name: 'Ember',
    type: 'FIRE',
    category: 'Special',
    contest: 'Cute',
    pp: '25',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 53,
    name: 'Flamethrower',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 54,
    name: 'Mist',
    type: 'ICE',
    category: 'Status',
    contest: 'Beautiful',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 55,
    name: 'Water Gun',
    type: 'WATER',
    category: 'Special',
    contest: 'Cute',
    pp: '25',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 56,
    name: 'Hydro Pump',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '110',
    accuracy: '80%',
    gen: 1,
  },
  {
    id: 57,
    name: 'Surf',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 58,
    name: 'Ice Beam',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 59,
    name: 'Blizzard',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '110',
    accuracy: '70%',
    gen: 1,
  },
  {
    id: 60,
    name: 'Psybeam',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 61,
    name: 'Bubble Beam',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 62,
    name: 'Aurora Beam',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 63,
    name: 'Hyper Beam',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 64,
    name: 'Peck',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '35',
    power: '35',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 65,
    name: 'Drill Peck',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 66,
    name: 'Submission',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '80',
    accuracy: '80%',
    gen: 1,
  },
  {
    id: 67,
    name: 'Low Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 68,
    name: 'Counter',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 69,
    name: 'Seismic Toss',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 70,
    name: 'Strength',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 71,
    name: 'Absorb',
    type: 'GRASS',
    category: 'Special',
    contest: 'Clever',
    pp: '25',
    power: '20',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 72,
    name: 'Mega Drain',
    type: 'GRASS',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 73,
    name: 'Leech Seed',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 74,
    name: 'Growth',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 75,
    name: 'Razor Leaf',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Cool',
    pp: '25',
    power: '55',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 76,
    name: 'Solar Beam',
    type: 'GRASS',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 77,
    name: 'Poison Powder',
    type: 'POISON',
    category: 'Status',
    contest: 'Clever',
    pp: '35',
    power: '—',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 78,
    name: 'Stun Spore',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '30',
    power: '—',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 79,
    name: 'Sleep Powder',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 80,
    name: 'Petal Dance',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 81,
    name: 'String Shot',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '95%',
    gen: 1,
  },
  {
    id: 82,
    name: 'Dragon Rage',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 83,
    name: 'Fire Spin',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '35',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 84,
    name: 'Thunder Shock',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 85,
    name: 'Thunderbolt',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 86,
    name: 'Thunder Wave',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 87,
    name: 'Thunder',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '110',
    accuracy: '70%',
    gen: 1,
  },
  {
    id: 88,
    name: 'Rock Throw',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '50',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 89,
    name: 'Earthquake',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '100',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 90,
    name: 'Fissure',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '30%',
    gen: 1,
  },
  {
    id: 91,
    name: 'Dig',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 92,
    name: 'Toxic',
    type: 'POISON',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 93,
    name: 'Confusion',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '25',
    power: '50',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 94,
    name: 'Psychic',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 95,
    name: 'Hypnosis',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '60%',
    gen: 1,
  },
  {
    id: 96,
    name: 'Meditate',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 97,
    name: 'Agility',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cool',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 98,
    name: 'Quick Attack',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 99,
    name: 'Rage',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '20',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 100,
    name: 'Teleport',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 101,
    name: 'Night Shade',
    type: 'GHOST',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 102,
    name: 'Mimic',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 103,
    name: 'Screech',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 104,
    name: 'Double Team',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cool',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 105,
    name: 'Recover',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 106,
    name: 'Harden',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 107,
    name: 'Minimize',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 108,
    name: 'Smokescreen',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 109,
    name: 'Confuse Ray',
    type: 'GHOST',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 110,
    name: 'Withdraw',
    type: 'WATER',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 111,
    name: 'Defense Curl',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 112,
    name: 'Barrier',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 113,
    name: 'Light Screen',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 114,
    name: 'Haze',
    type: 'ICE',
    category: 'Status',
    contest: 'Beautiful',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 115,
    name: 'Reflect',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 116,
    name: 'Focus Energy',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cool',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 117,
    name: 'Bide',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 118,
    name: 'Metronome',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 119,
    name: 'Mirror Move',
    type: 'FLYING',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 120,
    name: 'Self-Destruct',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '200',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 121,
    name: 'Egg Bomb',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '100',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 122,
    name: 'Lick',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Cute',
    pp: '30',
    power: '30',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 123,
    name: 'Smog',
    type: 'POISON',
    category: 'Special',
    contest: 'Tough',
    pp: '20',
    power: '30',
    accuracy: '70%',
    gen: 1,
  },
  {
    id: 124,
    name: 'Sludge',
    type: 'POISON',
    category: 'Special',
    contest: 'Tough',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 125,
    name: 'Bone Club',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '65',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 126,
    name: 'Fire Blast',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '110',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 127,
    name: 'Waterfall',
    type: 'WATER',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 128,
    name: 'Clamp',
    type: 'WATER',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '35',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 129,
    name: 'Swift',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 130,
    name: 'Skull Bash',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '130',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 131,
    name: 'Spike Cannon',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '20',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 132,
    name: 'Constrict',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '35',
    power: '10',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 133,
    name: 'Amnesia',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 134,
    name: 'Kinesis',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '80%',
    gen: 1,
  },
  {
    id: 135,
    name: 'Soft-Boiled',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 136,
    name: 'High Jump Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '130',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 137,
    name: 'Glare',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 138,
    name: 'Dream Eater',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '100',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 139,
    name: 'Poison Gas',
    type: 'POISON',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 140,
    name: 'Barrage',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '15',
    accuracy: '85%',
    gen: 1,
  },
  {
    id: 141,
    name: 'Leech Life',
    type: 'BUG',
    category: 'Physical',
    contest: 'Clever',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 142,
    name: 'Lovely Kiss',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '75%',
    gen: 1,
  },
  {
    id: 143,
    name: 'Sky Attack',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '140',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 144,
    name: 'Transform',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 145,
    name: 'Bubble',
    type: 'WATER',
    category: 'Special',
    contest: 'Cute',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 146,
    name: 'Dizzy Punch',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '70',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 147,
    name: 'Spore',
    type: 'GRASS',
    category: 'Status',
    contest: 'Beautiful',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 148,
    name: 'Flash',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 149,
    name: 'Psywave',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 150,
    name: 'Splash',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 151,
    name: 'Acid Armor',
    type: 'POISON',
    category: 'Status',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 152,
    name: 'Crabhammer',
    type: 'WATER',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '100',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 153,
    name: 'Explosion',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '250',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 154,
    name: 'Fury Swipes',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '18',
    accuracy: '80%',
    gen: 1,
  },
  {
    id: 155,
    name: 'Bonemerang',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '50',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 156,
    name: 'Rest',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 157,
    name: 'Rock Slide',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '75',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 158,
    name: 'Hyper Fang',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '80',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 159,
    name: 'Sharpen',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 160,
    name: 'Conversion',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 161,
    name: 'Tri Attack',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 162,
    name: 'Super Fang',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '90%',
    gen: 1,
  },
  {
    id: 163,
    name: 'Slash',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 1,
  },
  {
    id: 164,
    name: 'Substitute',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 165,
    name: 'Struggle',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '1',
    power: '50',
    accuracy: '—',
    gen: 1,
  },
  {
    id: 166,
    name: 'Sketch',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 167,
    name: 'Triple Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '10',
    accuracy: '90%',
    gen: 2,
  },
  {
    id: 168,
    name: 'Thief',
    type: 'DARK',
    category: 'Physical',
    contest: 'Tough',
    pp: '25',
    power: '60',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 169,
    name: 'Spider Web',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 170,
    name: 'Mind Reader',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 171,
    name: 'Nightmare',
    type: 'GHOST',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 172,
    name: 'Flame Wheel',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '25',
    power: '60',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 173,
    name: 'Snore',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cute',
    pp: '15',
    power: '50',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 174,
    name: 'Curse',
    type: 'GHOST',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 175,
    name: 'Flail',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 176,
    name: 'Conversion 2',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 177,
    name: 'Aeroblast',
    type: 'FLYING',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '100',
    accuracy: '95%',
    gen: 2,
  },
  {
    id: 178,
    name: 'Cotton Spore',
    type: 'GRASS',
    category: 'Status',
    contest: 'Beautiful',
    pp: '40',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 179,
    name: 'Reversal',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 180,
    name: 'Spite',
    type: 'GHOST',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 181,
    name: 'Powder Snow',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '25',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 182,
    name: 'Protect',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 183,
    name: 'Mach Punch',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 184,
    name: 'Scary Face',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 185,
    name: 'Feint Attack',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 186,
    name: 'Sweet Kiss',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '75%',
    gen: 2,
  },
  {
    id: 187,
    name: 'Belly Drum',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 188,
    name: 'Sludge Bomb',
    type: 'POISON',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 189,
    name: 'Mud-Slap',
    type: 'GROUND',
    category: 'Special',
    contest: 'Cute',
    pp: '10',
    power: '20',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 190,
    name: 'Octazooka',
    type: 'WATER',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '65',
    accuracy: '85%',
    gen: 2,
  },
  {
    id: 191,
    name: 'Spikes',
    type: 'GROUND',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 192,
    name: 'Zap Cannon',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '120',
    accuracy: '50%',
    gen: 2,
  },
  {
    id: 193,
    name: 'Foresight',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 194,
    name: 'Destiny Bond',
    type: 'GHOST',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 195,
    name: 'Perish Song',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 196,
    name: 'Icy Wind',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '55',
    accuracy: '95%',
    gen: 2,
  },
  {
    id: 197,
    name: 'Detect',
    type: 'FIGHTING',
    category: 'Status',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 198,
    name: 'Bone Rush',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '25',
    accuracy: '90%',
    gen: 2,
  },
  {
    id: 199,
    name: 'Lock-On',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 200,
    name: 'Outrage',
    type: 'DRAGON',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 201,
    name: 'Sandstorm',
    type: 'ROCK',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 202,
    name: 'Giga Drain',
    type: 'GRASS',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 203,
    name: 'Endure',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 204,
    name: 'Charm',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 205,
    name: 'Rollout',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '30',
    accuracy: '90%',
    gen: 2,
  },
  {
    id: 206,
    name: 'False Swipe',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '40',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 207,
    name: 'Swagger',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '85%',
    gen: 2,
  },
  {
    id: 208,
    name: 'Milk Drink',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 209,
    name: 'Spark',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 210,
    name: 'Fury Cutter',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '40',
    accuracy: '95%',
    gen: 2,
  },
  {
    id: 211,
    name: 'Steel Wing',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '25',
    power: '70',
    accuracy: '90%',
    gen: 2,
  },
  {
    id: 212,
    name: 'Mean Look',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 213,
    name: 'Attract',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 214,
    name: 'Sleep Talk',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 215,
    name: 'Heal Bell',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 216,
    name: 'Return',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 217,
    name: 'Present',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '90%',
    gen: 2,
  },
  {
    id: 218,
    name: 'Frustration',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 219,
    name: 'Safeguard',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '25',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 220,
    name: 'Pain Split',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 221,
    name: 'Sacred Fire',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '100',
    accuracy: '95%',
    gen: 2,
  },
  {
    id: 222,
    name: 'Magnitude',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 223,
    name: 'Dynamic Punch',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '100',
    accuracy: '50%',
    gen: 2,
  },
  {
    id: 224,
    name: 'Megahorn',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '120',
    accuracy: '85%',
    gen: 2,
  },
  {
    id: 225,
    name: 'Dragon Breath',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 226,
    name: 'Baton Pass',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 227,
    name: 'Encore',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 228,
    name: 'Pursuit',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 229,
    name: 'Rapid Spin',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '40',
    power: '50',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 230,
    name: 'Sweet Scent',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 231,
    name: 'Iron Tail',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '100',
    accuracy: '75%',
    gen: 2,
  },
  {
    id: 232,
    name: 'Metal Claw',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '35',
    power: '50',
    accuracy: '95%',
    gen: 2,
  },
  {
    id: 233,
    name: 'Vital Throw',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '70',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 234,
    name: 'Morning Sun',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 235,
    name: 'Synthesis',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 236,
    name: 'Moonlight',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 237,
    name: 'Hidden Power',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '60',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 238,
    name: 'Cross Chop',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '100',
    accuracy: '80%',
    gen: 2,
  },
  {
    id: 239,
    name: 'Twister',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 240,
    name: 'Rain Dance',
    type: 'WATER',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 241,
    name: 'Sunny Day',
    type: 'FIRE',
    category: 'Status',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 242,
    name: 'Crunch',
    type: 'DARK',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 243,
    name: 'Mirror Coat',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 244,
    name: 'Psych Up',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 2,
  },
  {
    id: 245,
    name: 'Extreme Speed',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '80',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 246,
    name: 'Ancient Power',
    type: 'ROCK',
    category: 'Special',
    contest: 'Tough',
    pp: '5',
    power: '60',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 247,
    name: 'Shadow Ball',
    type: 'GHOST',
    category: 'Special',
    contest: 'Clever',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 248,
    name: 'Future Sight',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 249,
    name: 'Rock Smash',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '40',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 250,
    name: 'Whirlpool',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '35',
    accuracy: '85%',
    gen: 2,
  },
  {
    id: 251,
    name: 'Beat Up',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 2,
  },
  {
    id: 252,
    name: 'Fake Out',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '40',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 253,
    name: 'Uproar',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cute',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 254,
    name: 'Stockpile',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 255,
    name: 'Spit Up',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 256,
    name: 'Swallow',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 257,
    name: 'Heat Wave',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '95',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 258,
    name: 'Hail',
    type: 'ICE',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 259,
    name: 'Torment',
    type: 'DARK',
    category: 'Status',
    contest: 'Tough',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 260,
    name: 'Flatter',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 261,
    name: 'Will-O-Wisp',
    type: 'FIRE',
    category: 'Status',
    contest: 'Beautiful',
    pp: '15',
    power: '—',
    accuracy: '85%',
    gen: 3,
  },
  {
    id: 262,
    name: 'Memento',
    type: 'DARK',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 263,
    name: 'Facade',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 264,
    name: 'Focus Punch',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '150',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 265,
    name: 'Smelling Salts',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '70',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 266,
    name: 'Follow Me',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 267,
    name: 'Nature Power',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 268,
    name: 'Charge',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 269,
    name: 'Taunt',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 270,
    name: 'Helping Hand',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 271,
    name: 'Trick',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 272,
    name: 'Role Play',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 273,
    name: 'Wish',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 274,
    name: 'Assist',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 275,
    name: 'Ingrain',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 276,
    name: 'Superpower',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 277,
    name: 'Magic Coat',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 278,
    name: 'Recycle',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 279,
    name: 'Revenge',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 280,
    name: 'Brick Break',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 281,
    name: 'Yawn',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 282,
    name: 'Knock Off',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 283,
    name: 'Endeavor',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 284,
    name: 'Eruption',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 285,
    name: 'Skill Swap',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 286,
    name: 'Imprison',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 287,
    name: 'Refresh',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 288,
    name: 'Grudge',
    type: 'GHOST',
    category: 'Status',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 289,
    name: 'Snatch',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 290,
    name: 'Secret Power',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 291,
    name: 'Dive',
    type: 'WATER',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 292,
    name: 'Arm Thrust',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '15',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 293,
    name: 'Camouflage',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 294,
    name: 'Tail Glow',
    type: 'BUG',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 295,
    name: 'Luster Purge',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '5',
    power: '70',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 296,
    name: 'Mist Ball',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '5',
    power: '70',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 297,
    name: 'Feather Dance',
    type: 'FLYING',
    category: 'Status',
    contest: 'Beautiful',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 298,
    name: 'Teeter Dance',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 299,
    name: 'Blaze Kick',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '85',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 300,
    name: 'Mud Sport',
    type: 'GROUND',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 301,
    name: 'Ice Ball',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '20',
    power: '30',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 302,
    name: 'Needle Arm',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '60',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 303,
    name: 'Slack Off',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 304,
    name: 'Hyper Voice',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 305,
    name: 'Poison Fang',
    type: 'POISON',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '50',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 306,
    name: 'Crush Claw',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '75',
    accuracy: '95%',
    gen: 3,
  },
  {
    id: 307,
    name: 'Blast Burn',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 308,
    name: 'Hydro Cannon',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 309,
    name: 'Meteor Mash',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '90',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 310,
    name: 'Astonish',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Cute',
    pp: '15',
    power: '30',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 311,
    name: 'Weather Ball',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '50',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 312,
    name: 'Aromatherapy',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 313,
    name: 'Fake Tears',
    type: 'DARK',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 314,
    name: 'Air Cutter',
    type: 'FLYING',
    category: 'Special',
    contest: 'Cool',
    pp: '25',
    power: '60',
    accuracy: '95%',
    gen: 3,
  },
  {
    id: 315,
    name: 'Overheat',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '130',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 316,
    name: 'Odor Sleuth',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 317,
    name: 'Rock Tomb',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '60',
    accuracy: '95%',
    gen: 3,
  },
  {
    id: 318,
    name: 'Silver Wind',
    type: 'BUG',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '60',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 319,
    name: 'Metal Sound',
    type: 'STEEL',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '85%',
    gen: 3,
  },
  {
    id: 320,
    name: 'Grass Whistle',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '55%',
    gen: 3,
  },
  {
    id: 321,
    name: 'Tickle',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 322,
    name: 'Cosmic Power',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 323,
    name: 'Water Spout',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 324,
    name: 'Signal Beam',
    type: 'BUG',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 325,
    name: 'Shadow Punch',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 326,
    name: 'Extrasensory',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '80',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 327,
    name: 'Sky Uppercut',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '85',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 328,
    name: 'Sand Tomb',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '35',
    accuracy: '85%',
    gen: 3,
  },
  {
    id: 329,
    name: 'Sheer Cold',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '—',
    accuracy: '30%',
    gen: 3,
  },
  {
    id: 330,
    name: 'Muddy Water',
    type: 'WATER',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '90',
    accuracy: '85%',
    gen: 3,
  },
  {
    id: 331,
    name: 'Bullet Seed',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Cool',
    pp: '30',
    power: '25',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 332,
    name: 'Aerial Ace',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 333,
    name: 'Icicle Spear',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '30',
    power: '25',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 334,
    name: 'Iron Defense',
    type: 'STEEL',
    category: 'Status',
    contest: 'Tough',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 335,
    name: 'Block',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 336,
    name: 'Howl',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cool',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 337,
    name: 'Dragon Claw',
    type: 'DRAGON',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 338,
    name: 'Frenzy Plant',
    type: 'GRASS',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 339,
    name: 'Bulk Up',
    type: 'FIGHTING',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 340,
    name: 'Bounce',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cute',
    pp: '5',
    power: '85',
    accuracy: '85%',
    gen: 3,
  },
  {
    id: 341,
    name: 'Mud Shot',
    type: 'GROUND',
    category: 'Special',
    contest: 'Tough',
    pp: '15',
    power: '55',
    accuracy: '95%',
    gen: 3,
  },
  {
    id: 342,
    name: 'Poison Tail',
    type: 'POISON',
    category: 'Physical',
    contest: 'Clever',
    pp: '25',
    power: '50',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 343,
    name: 'Covet',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '25',
    power: '60',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 344,
    name: 'Volt Tackle',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 345,
    name: 'Magical Leaf',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 346,
    name: 'Water Sport',
    type: 'WATER',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 347,
    name: 'Calm Mind',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 348,
    name: 'Leaf Blade',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 349,
    name: 'Dragon Dance',
    type: 'DRAGON',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 350,
    name: 'Rock Blast',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '25',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 351,
    name: 'Shock Wave',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 3,
  },
  {
    id: 352,
    name: 'Water Pulse',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 353,
    name: 'Doom Desire',
    type: 'STEEL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '140',
    accuracy: '100%',
    gen: 3,
  },
  {
    id: 354,
    name: 'Psycho Boost',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '5',
    power: '140',
    accuracy: '90%',
    gen: 3,
  },
  {
    id: 355,
    name: 'Roost',
    type: 'FLYING',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 356,
    name: 'Gravity',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 357,
    name: 'Miracle Eye',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 358,
    name: 'Wake-Up Slap',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 359,
    name: 'Hammer Arm',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '100',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 360,
    name: 'Gyro Ball',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 361,
    name: 'Healing Wish',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 362,
    name: 'Brine',
    type: 'WATER',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '65',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 363,
    name: 'Natural Gift',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 364,
    name: 'Feint',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Clever',
    pp: '10',
    power: '30',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 365,
    name: 'Pluck',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 366,
    name: 'Tailwind',
    type: 'FLYING',
    category: 'Status',
    contest: 'Cool',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 367,
    name: 'Acupressure',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 368,
    name: 'Metal Burst',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 369,
    name: 'U-turn',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 370,
    name: 'Close Combat',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 371,
    name: 'Payback',
    type: 'DARK',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '50',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 372,
    name: 'Assurance',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 373,
    name: 'Embargo',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 374,
    name: 'Fling',
    type: 'DARK',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 375,
    name: 'Psycho Shift',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 376,
    name: 'Trump Card',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 377,
    name: 'Heal Block',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 378,
    name: 'Wring Out',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 379,
    name: 'Power Trick',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 380,
    name: 'Gastro Acid',
    type: 'POISON',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 381,
    name: 'Lucky Chant',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 382,
    name: 'Me First',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 383,
    name: 'Copycat',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 384,
    name: 'Power Swap',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 385,
    name: 'Guard Swap',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 386,
    name: 'Punishment',
    type: 'DARK',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 387,
    name: 'Last Resort',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '5',
    power: '140',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 388,
    name: 'Worry Seed',
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 389,
    name: 'Sucker Punch',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '5',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 390,
    name: 'Toxic Spikes',
    type: 'POISON',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 391,
    name: 'Heart Swap',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 392,
    name: 'Aqua Ring',
    type: 'WATER',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 393,
    name: 'Magnet Rise',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 394,
    name: 'Flare Blitz',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 395,
    name: 'Force Palm',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 396,
    name: 'Aura Sphere',
    type: 'FIGHTING',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '80',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 397,
    name: 'Rock Polish',
    type: 'ROCK',
    category: 'Status',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 398,
    name: 'Poison Jab',
    type: 'POISON',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 399,
    name: 'Dark Pulse',
    type: 'DARK',
    category: 'Special',
    contest: 'Cool',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 400,
    name: 'Night Slash',
    type: 'DARK',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 401,
    name: 'Aqua Tail',
    type: 'WATER',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 402,
    name: 'Seed Bomb',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 403,
    name: 'Air Slash',
    type: 'FLYING',
    category: 'Special',
    contest: 'Cool',
    pp: '15',
    power: '75',
    accuracy: '95%',
    gen: 4,
  },
  {
    id: 404,
    name: 'X-Scissor',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 405,
    name: 'Bug Buzz',
    type: 'BUG',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 406,
    name: 'Dragon Pulse',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 407,
    name: 'Dragon Rush',
    type: 'DRAGON',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '100',
    accuracy: '75%',
    gen: 4,
  },
  {
    id: 408,
    name: 'Power Gem',
    type: 'ROCK',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 409,
    name: 'Drain Punch',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 410,
    name: 'Vacuum Wave',
    type: 'FIGHTING',
    category: 'Special',
    contest: 'Cool',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 411,
    name: 'Focus Blast',
    type: 'FIGHTING',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '120',
    accuracy: '70%',
    gen: 4,
  },
  {
    id: 412,
    name: 'Energy Ball',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 413,
    name: 'Brave Bird',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 414,
    name: 'Earth Power',
    type: 'GROUND',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 415,
    name: 'Switcheroo',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 416,
    name: 'Giga Impact',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 417,
    name: 'Nasty Plot',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 418,
    name: 'Bullet Punch',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Tough',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 419,
    name: 'Avalanche',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 420,
    name: 'Ice Shard',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 421,
    name: 'Shadow Claw',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 422,
    name: 'Thunder Fang',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '65',
    accuracy: '95%',
    gen: 4,
  },
  {
    id: 423,
    name: 'Ice Fang',
    type: 'ICE',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '65',
    accuracy: '95%',
    gen: 4,
  },
  {
    id: 424,
    name: 'Fire Fang',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '65',
    accuracy: '95%',
    gen: 4,
  },
  {
    id: 425,
    name: 'Shadow Sneak',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Clever',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 426,
    name: 'Mud Bomb',
    type: 'GROUND',
    category: 'Special',
    contest: 'Cute',
    pp: '10',
    power: '65',
    accuracy: '85%',
    gen: 4,
  },
  {
    id: 427,
    name: 'Psycho Cut',
    type: 'PSYCHIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 428,
    name: 'Zen Headbutt',
    type: 'PSYCHIC',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '80',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 429,
    name: 'Mirror Shot',
    type: 'STEEL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '65',
    accuracy: '85%',
    gen: 4,
  },
  {
    id: 430,
    name: 'Flash Cannon',
    type: 'STEEL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 431,
    name: 'Rock Climb',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '90',
    accuracy: '85%',
    gen: 4,
  },
  {
    id: 432,
    name: 'Defog',
    type: 'FLYING',
    category: 'Status',
    contest: 'Cool',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 433,
    name: 'Trick Room',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 434,
    name: 'Draco Meteor',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '130',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 435,
    name: 'Discharge',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 436,
    name: 'Lava Plume',
    type: 'FIRE',
    category: 'Special',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 437,
    name: 'Leaf Storm',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '130',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 438,
    name: 'Power Whip',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '120',
    accuracy: '85%',
    gen: 4,
  },
  {
    id: 439,
    name: 'Rock Wrecker',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 440,
    name: 'Cross Poison',
    type: 'POISON',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 441,
    name: 'Gunk Shot',
    type: 'POISON',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '120',
    accuracy: '80%',
    gen: 4,
  },
  {
    id: 442,
    name: 'Iron Head',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 443,
    name: 'Magnet Bomb',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '60',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 444,
    name: 'Stone Edge',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '100',
    accuracy: '80%',
    gen: 4,
  },
  {
    id: 445,
    name: 'Captivate',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 446,
    name: 'Stealth Rock',
    type: 'ROCK',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 447,
    name: 'Grass Knot',
    type: 'GRASS',
    category: 'Special',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 448,
    name: 'Chatter',
    type: 'FLYING',
    category: 'Special',
    contest: 'Cute',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 449,
    name: 'Judgment',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '100',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 450,
    name: 'Bug Bite',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 451,
    name: 'Charge Beam',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '50',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 452,
    name: 'Wood Hammer',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 453,
    name: 'Aqua Jet',
    type: 'WATER',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 454,
    name: 'Attack Order',
    type: 'BUG',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 455,
    name: 'Defend Order',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 456,
    name: 'Heal Order',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 457,
    name: 'Head Smash',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '150',
    accuracy: '80%',
    gen: 4,
  },
  {
    id: 458,
    name: 'Double Hit',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '35',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 459,
    name: 'Roar of Time',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '150',
    accuracy: '90%',
    gen: 4,
  },
  {
    id: 460,
    name: 'Spacial Rend',
    type: 'DRAGON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '100',
    accuracy: '95%',
    gen: 4,
  },
  {
    id: 461,
    name: 'Lunar Dance',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 4,
  },
  {
    id: 462,
    name: 'Crush Grip',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 463,
    name: 'Magma Storm',
    type: 'FIRE',
    category: 'Special',
    contest: 'Tough',
    pp: '5',
    power: '100',
    accuracy: '75%',
    gen: 4,
  },
  {
    id: 464,
    name: 'Dark Void',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '50%',
    gen: 4,
  },
  {
    id: 465,
    name: 'Seed Flare',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '120',
    accuracy: '85%',
    gen: 4,
  },
  {
    id: 466,
    name: 'Ominous Wind',
    type: 'GHOST',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '60',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 467,
    name: 'Shadow Force',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 4,
  },
  {
    id: 468,
    name: 'Hone Claws',
    type: 'DARK',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 469,
    name: 'Wide Guard',
    type: 'ROCK',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 470,
    name: 'Guard Split',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 471,
    name: 'Power Split',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 472,
    name: 'Wonder Room',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 473,
    name: 'Psyshock',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 474,
    name: 'Venoshock',
    type: 'POISON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '65',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 475,
    name: 'Autotomize',
    type: 'STEEL',
    category: 'Status',
    contest: 'Beautiful',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 476,
    name: 'Rage Powder',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 477,
    name: 'Telekinesis',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 478,
    name: 'Magic Room',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 479,
    name: 'Smack Down',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '50',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 480,
    name: 'Storm Throw',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 481,
    name: 'Flame Burst',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '70',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 482,
    name: 'Sludge Wave',
    type: 'POISON',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '95',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 483,
    name: 'Quiver Dance',
    type: 'BUG',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 484,
    name: 'Heavy Slam',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 485,
    name: 'Synchronoise',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 486,
    name: 'Electro Ball',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 487,
    name: 'Soak',
    type: 'WATER',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 488,
    name: 'Flame Charge',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Cool',
    pp: '20',
    power: '50',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 489,
    name: 'Coil',
    type: 'POISON',
    category: 'Status',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 490,
    name: 'Low Sweep',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Clever',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 491,
    name: 'Acid Spray',
    type: 'POISON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 492,
    name: 'Foul Play',
    type: 'DARK',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '95',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 493,
    name: 'Simple Beam',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 494,
    name: 'Entrainment',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 495,
    name: 'After You',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 496,
    name: 'Round',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 497,
    name: 'Echoed Voice',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '40',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 498,
    name: 'Chip Away',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 499,
    name: 'Clear Smog',
    type: 'POISON',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '50',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 500,
    name: 'Stored Power',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '20',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 501,
    name: 'Quick Guard',
    type: 'FIGHTING',
    category: 'Status',
    contest: 'Cool',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 502,
    name: 'Ally Switch',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 503,
    name: 'Scald',
    type: 'WATER',
    category: 'Special',
    contest: 'Tough',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 504,
    name: 'Shell Smash',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 505,
    name: 'Heal Pulse',
    type: 'PSYCHIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 506,
    name: 'Hex',
    type: 'GHOST',
    category: 'Special',
    contest: 'Clever',
    pp: '10',
    power: '65',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 507,
    name: 'Sky Drop',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 508,
    name: 'Shift Gear',
    type: 'STEEL',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 509,
    name: 'Circle Throw',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '60',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 510,
    name: 'Incinerate',
    type: 'FIRE',
    category: 'Special',
    contest: 'Tough',
    pp: '15',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 511,
    name: 'Quash',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 512,
    name: 'Acrobatics',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '55',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 513,
    name: 'Reflect Type',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 514,
    name: 'Retaliate',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '70',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 515,
    name: 'Final Gambit',
    type: 'FIGHTING',
    category: 'Special',
    contest: 'Tough',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 516,
    name: 'Bestow',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 517,
    name: 'Inferno',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '100',
    accuracy: '50%',
    gen: 5,
  },
  {
    id: 518,
    name: 'Water Pledge',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 519,
    name: 'Fire Pledge',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 520,
    name: 'Grass Pledge',
    type: 'GRASS',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 521,
    name: 'Volt Switch',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 522,
    name: 'Struggle Bug',
    type: 'BUG',
    category: 'Special',
    contest: 'Cute',
    pp: '20',
    power: '50',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 523,
    name: 'Bulldoze',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 524,
    name: 'Frost Breath',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '60',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 525,
    name: 'Dragon Tail',
    type: 'DRAGON',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '60',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 526,
    name: 'Work Up',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 527,
    name: 'Electroweb',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '55',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 528,
    name: 'Wild Charge',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 529,
    name: 'Drill Run',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '80',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 530,
    name: 'Dual Chop',
    type: 'DRAGON',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '40',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 531,
    name: 'Heart Stamp',
    type: 'PSYCHIC',
    category: 'Physical',
    contest: 'Cute',
    pp: '25',
    power: '60',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 532,
    name: 'Horn Leech',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 533,
    name: 'Sacred Sword',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Cool',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 534,
    name: 'Razor Shell',
    type: 'WATER',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '75',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 535,
    name: 'Heat Crash',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 536,
    name: 'Leaf Tornado',
    type: 'GRASS',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '65',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 537,
    name: 'Steamroller',
    type: 'BUG',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 538,
    name: 'Cotton Guard',
    type: 'GRASS',
    category: 'Status',
    contest: 'Cute',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 5,
  },
  {
    id: 539,
    name: 'Night Daze',
    type: 'DARK',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '85',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 540,
    name: 'Psystrike',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '100',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 541,
    name: 'Tail Slap',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '25',
    accuracy: '85%',
    gen: 5,
  },
  {
    id: 542,
    name: 'Hurricane',
    type: 'FLYING',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '110',
    accuracy: '70%',
    gen: 5,
  },
  {
    id: 543,
    name: 'Head Charge',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Tough',
    pp: '15',
    power: '120',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 544,
    name: 'Gear Grind',
    type: 'STEEL',
    category: 'Physical',
    contest: 'Clever',
    pp: '15',
    power: '50',
    accuracy: '85%',
    gen: 5,
  },
  {
    id: 545,
    name: 'Searing Shot',
    type: 'FIRE',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 546,
    name: 'Techno Blast',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Cool',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 547,
    name: 'Relic Song',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 548,
    name: 'Secret Sword',
    type: 'FIGHTING',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 549,
    name: 'Glaciate',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '65',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 550,
    name: 'Bolt Strike',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '130',
    accuracy: '85%',
    gen: 5,
  },
  {
    id: 551,
    name: 'Blue Flare',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '130',
    accuracy: '85%',
    gen: 5,
  },
  {
    id: 552,
    name: 'Fiery Dance',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 553,
    name: 'Freeze Shock',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '140',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 554,
    name: 'Ice Burn',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '140',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 555,
    name: 'Snarl',
    type: 'DARK',
    category: 'Special',
    contest: 'Tough',
    pp: '15',
    power: '55',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 556,
    name: 'Icicle Crash',
    type: 'ICE',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '85',
    accuracy: '90%',
    gen: 5,
  },
  {
    id: 557,
    name: 'V-create',
    type: 'FIRE',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '180',
    accuracy: '95%',
    gen: 5,
  },
  {
    id: 558,
    name: 'Fusion Flare',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 559,
    name: 'Fusion Bolt',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cool',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 5,
  },
  {
    id: 560,
    name: 'Flying Press',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '100',
    accuracy: '95%',
    gen: 6,
  },
  {
    id: 561,
    name: 'Mat Block',
    type: 'FIGHTING',
    category: 'Status',
    contest: 'Cool',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 562,
    name: 'Belch',
    type: 'POISON',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '120',
    accuracy: '90%',
    gen: 6,
  },
  {
    id: 563,
    name: 'Rototiller',
    type: 'GROUND',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 564,
    name: 'Sticky Web',
    type: 'BUG',
    category: 'Status',
    contest: 'Tough',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 565,
    name: 'Fell Stinger',
    type: 'BUG',
    category: 'Physical',
    contest: 'Cool',
    pp: '25',
    power: '50',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 566,
    name: 'Phantom Force',
    type: 'GHOST',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 567,
    name: 'Trick-or-Treat',
    type: 'GHOST',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 568,
    name: 'Noble Roar',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Tough',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 569,
    name: 'Ion Deluge',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Beautiful',
    pp: '25',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 570,
    name: 'Parabolic Charge',
    type: 'ELECTRIC',
    category: 'Special',
    contest: 'Clever',
    pp: '20',
    power: '65',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 571,
    name: "Forest's Curse",
    type: 'GRASS',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 572,
    name: 'Petal Blizzard',
    type: 'GRASS',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 573,
    name: 'Freeze-Dry',
    type: 'ICE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 574,
    name: 'Disarming Voice',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Cute',
    pp: '15',
    power: '40',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 575,
    name: 'Parting Shot',
    type: 'DARK',
    category: 'Status',
    contest: 'Cool',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 576,
    name: 'Topsy-Turvy',
    type: 'DARK',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 577,
    name: 'Draining Kiss',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Cute',
    pp: '10',
    power: '50',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 578,
    name: 'Crafty Shield',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 579,
    name: 'Flower Shield',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 580,
    name: 'Grassy Terrain',
    type: 'GRASS',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 581,
    name: 'Misty Terrain',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 582,
    name: 'Electrify',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 583,
    name: 'Play Rough',
    type: 'FAIRY',
    category: 'Physical',
    contest: 'Cute',
    pp: '10',
    power: '90',
    accuracy: '90%',
    gen: 6,
  },
  {
    id: 584,
    name: 'Fairy Wind',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Beautiful',
    pp: '30',
    power: '40',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 585,
    name: 'Moonblast',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Beautiful',
    pp: '15',
    power: '95',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 586,
    name: 'Boomburst',
    type: 'NORMAL',
    category: 'Special',
    contest: 'Tough',
    pp: '10',
    power: '140',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 587,
    name: 'Fairy Lock',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 588,
    name: "King's Shield",
    type: 'STEEL',
    category: 'Status',
    contest: 'Cool',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 589,
    name: 'Play Nice',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 590,
    name: 'Confide',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 591,
    name: 'Diamond Storm',
    type: 'ROCK',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '100',
    accuracy: '95%',
    gen: 6,
  },
  {
    id: 592,
    name: 'Steam Eruption',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '110',
    accuracy: '95%',
    gen: 6,
  },
  {
    id: 593,
    name: 'Hyperspace Hole',
    type: 'PSYCHIC',
    category: 'Special',
    contest: 'Clever',
    pp: '5',
    power: '80',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 594,
    name: 'Water Shuriken',
    type: 'WATER',
    category: 'Special',
    contest: 'Cool',
    pp: '20',
    power: '15',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 595,
    name: 'Mystical Fire',
    type: 'FIRE',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 596,
    name: 'Spiky Shield',
    type: 'GRASS',
    category: 'Status',
    contest: 'Tough',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 597,
    name: 'Aromatic Mist',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Beautiful',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 598,
    name: 'Eerie Impulse',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 599,
    name: 'Venom Drench',
    type: 'POISON',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 600,
    name: 'Powder',
    type: 'BUG',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 601,
    name: 'Geomancy',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Beautiful',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 602,
    name: 'Magnetic Flux',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 603,
    name: 'Happy Hour',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 604,
    name: 'Electric Terrain',
    type: 'ELECTRIC',
    category: 'Status',
    contest: 'Clever',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 605,
    name: 'Dazzling Gleam',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 606,
    name: 'Celebrate',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 607,
    name: 'Hold Hands',
    type: 'NORMAL',
    category: 'Status',
    contest: 'Cute',
    pp: '40',
    power: '—',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 608,
    name: 'Baby-Doll Eyes',
    type: 'FAIRY',
    category: 'Status',
    contest: 'Cute',
    pp: '30',
    power: '—',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 609,
    name: 'Nuzzle',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: 'Cute',
    pp: '20',
    power: '20',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 610,
    name: 'Hold Back',
    type: 'NORMAL',
    category: 'Physical',
    contest: 'Cool',
    pp: '40',
    power: '40',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 611,
    name: 'Infestation',
    type: 'BUG',
    category: 'Special',
    contest: 'Cute',
    pp: '20',
    power: '20',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 612,
    name: 'Power-Up Punch',
    type: 'FIGHTING',
    category: 'Physical',
    contest: 'Tough',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 613,
    name: 'Oblivion Wing',
    type: 'FLYING',
    category: 'Special',
    contest: 'Cool',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 614,
    name: 'Thousand Arrows',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 615,
    name: 'Thousand Waves',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Tough',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 616,
    name: "Land's Wrath",
    type: 'GROUND',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 617,
    name: 'Light of Ruin',
    type: 'FAIRY',
    category: 'Special',
    contest: 'Beautiful',
    pp: '5',
    power: '140',
    accuracy: '90%',
    gen: 6,
  },
  {
    id: 618,
    name: 'Origin Pulse',
    type: 'WATER',
    category: 'Special',
    contest: 'Beautiful',
    pp: '10',
    power: '110',
    accuracy: '85%',
    gen: 6,
  },
  {
    id: 619,
    name: 'Precipice Blades',
    type: 'GROUND',
    category: 'Physical',
    contest: 'Cool',
    pp: '10',
    power: '120',
    accuracy: '85%',
    gen: 6,
  },
  {
    id: 620,
    name: 'Dragon Ascent',
    type: 'FLYING',
    category: 'Physical',
    contest: 'Beautiful',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 6,
  },
  {
    id: 621,
    name: 'Hyperspace Fury',
    type: 'DARK',
    category: 'Physical',
    contest: 'Tough',
    pp: '5',
    power: '100',
    accuracy: '—',
    gen: 6,
  },
  {
    id: 622,
    name: 'Breakneck Blitz',
    type: 'NORMAL',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 623,
    name: 'Breakneck Blitz',
    type: 'NORMAL',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 624,
    name: 'All-Out Pummeling',
    type: 'FIGHTING',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 625,
    name: 'All-Out Pummeling',
    type: 'FIGHTING',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 626,
    name: 'Supersonic Skystrike',
    type: 'FLYING',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 627,
    name: 'Supersonic Skystrike',
    type: 'FLYING',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 628,
    name: 'Acid Downpour',
    type: 'POISON',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 629,
    name: 'Acid Downpour',
    type: 'POISON',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 630,
    name: 'Tectonic Rage',
    type: 'GROUND',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 631,
    name: 'Tectonic Rage',
    type: 'GROUND',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 632,
    name: 'Continental Crush',
    type: 'ROCK',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 633,
    name: 'Continental Crush',
    type: 'ROCK',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 634,
    name: 'Savage Spin-Out',
    type: 'BUG',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 635,
    name: 'Savage Spin-Out',
    type: 'BUG',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 636,
    name: 'Never-Ending Nightmare',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 637,
    name: 'Never-Ending Nightmare',
    type: 'GHOST',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 638,
    name: 'Corkscrew Crash',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 639,
    name: 'Corkscrew Crash',
    type: 'STEEL',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 640,
    name: 'Inferno Overdrive',
    type: 'FIRE',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 641,
    name: 'Inferno Overdrive',
    type: 'FIRE',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 642,
    name: 'Hydro Vortex',
    type: 'WATER',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 643,
    name: 'Hydro Vortex',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 644,
    name: 'Bloom Doom',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 645,
    name: 'Bloom Doom',
    type: 'GRASS',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 646,
    name: 'Gigavolt Havoc',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 647,
    name: 'Gigavolt Havoc',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 648,
    name: 'Shattered Psyche',
    type: 'PSYCHIC',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 649,
    name: 'Shattered Psyche',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 650,
    name: 'Subzero Slammer',
    type: 'ICE',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 651,
    name: 'Subzero Slammer',
    type: 'ICE',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 652,
    name: 'Devastating Drake',
    type: 'DRAGON',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 653,
    name: 'Devastating Drake',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 654,
    name: 'Black Hole Eclipse',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 655,
    name: 'Black Hole Eclipse',
    type: 'DARK',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 656,
    name: 'Twinkle Tackle',
    type: 'FAIRY',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 657,
    name: 'Twinkle Tackle',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 658,
    name: 'Catastropika',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '210',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 659,
    name: 'Shore Up',
    type: 'GROUND',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 660,
    name: 'First Impression',
    type: 'BUG',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 661,
    name: 'Baneful Bunker',
    type: 'POISON',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 662,
    name: 'Spirit Shackle',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 663,
    name: 'Darkest Lariat',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 664,
    name: 'Sparkling Aria',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 665,
    name: 'Ice Hammer',
    type: 'ICE',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '100',
    accuracy: '90%',
    gen: 7,
  },
  {
    id: 666,
    name: 'Floral Healing',
    type: 'FAIRY',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 667,
    name: 'High Horsepower',
    type: 'GROUND',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '95',
    accuracy: '95%',
    gen: 7,
  },
  {
    id: 668,
    name: 'Strength Sap',
    type: 'GRASS',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 669,
    name: 'Solar Blade',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '125',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 670,
    name: 'Leafage',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '40',
    power: '40',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 671,
    name: 'Spotlight',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 672,
    name: 'Toxic Thread',
    type: 'POISON',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 673,
    name: 'Laser Focus',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '30',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 674,
    name: 'Gear Up',
    type: 'STEEL',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 675,
    name: 'Throat Chop',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 676,
    name: 'Pollen Puff',
    type: 'BUG',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 677,
    name: 'Anchor Shot',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 678,
    name: 'Psychic Terrain',
    type: 'PSYCHIC',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 679,
    name: 'Lunge',
    type: 'BUG',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 680,
    name: 'Fire Lash',
    type: 'FIRE',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 681,
    name: 'Power Trip',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '20',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 682,
    name: 'Burn Up',
    type: 'FIRE',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '130',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 683,
    name: 'Speed Swap',
    type: 'PSYCHIC',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 684,
    name: 'Smart Strike',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '70',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 685,
    name: 'Purify',
    type: 'POISON',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 686,
    name: 'Revelation Dance',
    type: 'NORMAL',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 687,
    name: 'Core Enforcer',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 688,
    name: 'Trop Kick',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '70',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 689,
    name: 'Instruct',
    type: 'PSYCHIC',
    category: 'Status',
    contest: '???',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 690,
    name: 'Beak Blast',
    type: 'FLYING',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 691,
    name: 'Clanging Scales',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '110',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 692,
    name: 'Dragon Hammer',
    type: 'DRAGON',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 693,
    name: 'Brutal Swing',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 694,
    name: 'Aurora Veil',
    type: 'ICE',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 695,
    name: 'Sinister Arrow Raid',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '180',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 696,
    name: 'Malicious Moonsault',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '180',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 697,
    name: 'Oceanic Operetta',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '195',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 698,
    name: 'Guardian of Alola',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 699,
    name: 'Soul-Stealing 7-Star Strike',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '195',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 700,
    name: 'Stoked Sparksurfer',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '175',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 701,
    name: 'Pulverizing Pancake',
    type: 'NORMAL',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '210',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 702,
    name: 'Extreme Evoboost',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '1',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 703,
    name: 'Genesis Supernova',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '185',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 704,
    name: 'Shell Trap',
    type: 'FIRE',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 705,
    name: 'Fleur Cannon',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '130',
    accuracy: '90%',
    gen: 7,
  },
  {
    id: 706,
    name: 'Psychic Fangs',
    type: 'PSYCHIC',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 707,
    name: 'Stomping Tantrum',
    type: 'GROUND',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '75',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 708,
    name: 'Shadow Bone',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 709,
    name: 'Accelerock',
    type: 'ROCK',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '40',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 710,
    name: 'Liquidation',
    type: 'WATER',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 711,
    name: 'Prismatic Laser',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '160',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 712,
    name: 'Spectral Thief',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 713,
    name: 'Sunsteel Strike',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 714,
    name: 'Moongeist Beam',
    type: 'GHOST',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 715,
    name: 'Tearful Look',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 716,
    name: 'Zing Zap',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 717,
    name: "Nature's Madness",
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '90%',
    gen: 7,
  },
  {
    id: 718,
    name: 'Multi-Attack',
    type: 'NORMAL',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '120',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 719,
    name: '10,000,000 Volt Thunderbolt',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '195',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 720,
    name: 'Mind Blown',
    type: 'FIRE',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 721,
    name: 'Plasma Fists',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 722,
    name: 'Photon Geyser',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 723,
    name: 'Light That Burns the Sky',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '200',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 724,
    name: 'Searing Sunraze Smash',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '200',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 725,
    name: 'Menacing Moonraze Maelstrom',
    type: 'GHOST',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '200',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 726,
    name: "Let's Snuggle Forever",
    type: 'FAIRY',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '190',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 727,
    name: 'Splintered Stormshards',
    type: 'ROCK',
    category: 'Physical',
    contest: '???',
    pp: '1',
    power: '190',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 728,
    name: 'Clangorous Soulblaze',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '1',
    power: '185',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 729,
    name: 'Zippy Zap',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '50',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 730,
    name: 'Splishy Splash',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 731,
    name: 'Floaty Fall',
    type: 'FLYING',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '95%',
    gen: 7,
  },
  {
    id: 732,
    name: 'Pika Papow',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 733,
    name: 'Bouncy Bubble',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 734,
    name: 'Buzzy Buzz',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 735,
    name: 'Sizzly Slide',
    type: 'FIRE',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 736,
    name: 'Glitzy Glow',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 737,
    name: 'Baddy Bad',
    type: 'DARK',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 738,
    name: 'Sappy Seed',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 739,
    name: 'Freezy Frost',
    type: 'ICE',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 740,
    name: 'Sparkly Swirl',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '90',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 741,
    name: 'Veevee Volley',
    type: 'NORMAL',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '—',
    gen: 7,
  },
  {
    id: 742,
    name: 'Double Iron Bash',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '60',
    accuracy: '100%',
    gen: 7,
  },
  {
    id: 743,
    name: 'Max Guard',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 744,
    name: 'Dynamax Cannon',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 745,
    name: 'Snipe Shot',
    type: 'WATER',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 746,
    name: 'Jaw Lock',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 747,
    name: 'Stuff Cheeks',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 748,
    name: 'No Retreat',
    type: 'FIGHTING',
    category: 'Status',
    contest: '???',
    pp: '5',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 749,
    name: 'Tar Shot',
    type: 'ROCK',
    category: 'Status',
    contest: '???',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 750,
    name: 'Magic Powder',
    type: 'PSYCHIC',
    category: 'Status',
    contest: '???',
    pp: '20',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 751,
    name: 'Dragon Darts',
    type: 'DRAGON',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '50',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 752,
    name: 'Teatime',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 753,
    name: 'Octolock',
    type: 'FIGHTING',
    category: 'Status',
    contest: '???',
    pp: '15',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 754,
    name: 'Bolt Beak',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 755,
    name: 'Fishious Rend',
    type: 'WATER',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '85',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 756,
    name: 'Court Change',
    type: 'NORMAL',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 757,
    name: 'Max Flare',
    type: 'FIRE',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 758,
    name: 'Max Flutterby',
    type: 'BUG',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 759,
    name: 'Max Lightning',
    type: 'ELECTRIC',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 760,
    name: 'Max Strike',
    type: 'NORMAL',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 761,
    name: 'Max Knuckle',
    type: 'FIGHTING',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 762,
    name: 'Max Phantasm',
    type: 'GHOST',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 763,
    name: 'Max Hailstorm',
    type: 'ICE',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 764,
    name: 'Max Ooze',
    type: 'POISON',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 765,
    name: 'Max Geyser',
    type: 'WATER',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 766,
    name: 'Max Airstream',
    type: 'FLYING',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 767,
    name: 'Max Starfall',
    type: 'FAIRY',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 768,
    name: 'Max Wyrmwind',
    type: 'DRAGON',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 769,
    name: 'Max Mindstorm',
    type: 'PSYCHIC',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 770,
    name: 'Max Rockfall',
    type: 'ROCK',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 771,
    name: 'Max Quake',
    type: 'GROUND',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 772,
    name: 'Max Darkness',
    type: 'DARK',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 773,
    name: 'Max Overgrowth',
    type: 'GRASS',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 774,
    name: 'Max Steelspike',
    type: 'STEEL',
    category: '???',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 775,
    name: 'Clangorous Soul',
    type: 'DRAGON',
    category: 'Status',
    contest: '???',
    pp: '5',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 776,
    name: 'Body Press',
    type: 'FIGHTING',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 777,
    name: 'Decorate',
    type: 'FAIRY',
    category: 'Status',
    contest: '???',
    pp: '15',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 778,
    name: 'Drum Beating',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 779,
    name: 'Snap Trap',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '35',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 780,
    name: 'Pyro Ball',
    type: 'FIRE',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '120',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 781,
    name: 'Behemoth Blade',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 782,
    name: 'Behemoth Bash',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 783,
    name: 'Aura Wheel',
    type: 'ELECTRIC',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '110',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 784,
    name: 'Breaking Swipe',
    type: 'DRAGON',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '60',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 785,
    name: 'Branch Poke',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '40',
    power: '40',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 786,
    name: 'Overdrive',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 787,
    name: 'Apple Acid',
    type: 'GRASS',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 788,
    name: 'Grav Apple',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 789,
    name: 'Spirit Break',
    type: 'FAIRY',
    category: 'Physical',
    contest: '???',
    pp: '15',
    power: '75',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 790,
    name: 'Strange Steam',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '95%',
    gen: 8,
  },
  {
    id: 791,
    name: 'Life Dew',
    type: 'WATER',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 792,
    name: 'Obstruct',
    type: 'DARK',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 793,
    name: 'False Surrender',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 794,
    name: 'Meteor Assault',
    type: 'FIGHTING',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 795,
    name: 'Eternabeam',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '160',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 796,
    name: 'Steel Beam',
    type: 'STEEL',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '140',
    accuracy: '95%',
    gen: 8,
  },
  {
    id: 797,
    name: 'Expanding Force',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 798,
    name: 'Steel Roller',
    type: 'STEEL',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '130',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 799,
    name: 'Scale Shot',
    type: 'DRAGON',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '25',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 800,
    name: 'Meteor Beam',
    type: 'ROCK',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '120',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 801,
    name: 'Shell Side Arm',
    type: 'POISON',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 802,
    name: 'Misty Explosion',
    type: 'FAIRY',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '100',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 803,
    name: 'Grassy Glide',
    type: 'GRASS',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 804,
    name: 'Rising Voltage',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '20',
    power: '70',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 805,
    name: 'Terrain Pulse',
    type: 'NORMAL',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '50',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 806,
    name: 'Skitter Smack',
    type: 'BUG',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '70',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 807,
    name: 'Burning Jealousy',
    type: 'FIRE',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '70',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 808,
    name: 'Lash Out',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '75',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 809,
    name: 'Poltergeist',
    type: 'GHOST',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '110',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 810,
    name: 'Corrosive Gas',
    type: 'POISON',
    category: 'Status',
    contest: '???',
    pp: '40',
    power: '—',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 811,
    name: 'Coaching',
    type: 'FIGHTING',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 812,
    name: 'Flip Turn',
    type: 'WATER',
    category: 'Physical',
    contest: '???',
    pp: '20',
    power: '60',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 813,
    name: 'Triple Axel',
    type: 'ICE',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '20',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 814,
    name: 'Dual Wingbeat',
    type: 'FLYING',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '40',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 815,
    name: 'Scorching Sands',
    type: 'GROUND',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '70',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 816,
    name: 'Jungle Healing',
    type: 'GRASS',
    category: 'Status',
    contest: '???',
    pp: '10',
    power: '—',
    accuracy: '—',
    gen: 8,
  },
  {
    id: 817,
    name: 'Wicked Blow',
    type: 'DARK',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 818,
    name: 'Surging Strikes',
    type: 'WATER',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '25',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 819,
    name: 'Thunder Cage',
    type: 'ELECTRIC',
    category: 'Special',
    contest: '???',
    pp: '15',
    power: '80',
    accuracy: '90%',
    gen: 8,
  },
  {
    id: 820,
    name: 'Dragon Energy',
    type: 'DRAGON',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '150',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 821,
    name: 'Freezing Glare',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 822,
    name: 'Fiery Wrath',
    type: 'DARK',
    category: 'Special',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 823,
    name: 'Thunderous Kick',
    type: 'FIGHTING',
    category: 'Physical',
    contest: '???',
    pp: '10',
    power: '90',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 824,
    name: 'Glacial Lance',
    type: 'ICE',
    category: 'Physical',
    contest: '???',
    pp: '5',
    power: '130',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 825,
    name: 'Astral Barrage',
    type: 'GHOST',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '120',
    accuracy: '100%',
    gen: 8,
  },
  {
    id: 826,
    name: 'Eerie Spell',
    type: 'PSYCHIC',
    category: 'Special',
    contest: '???',
    pp: '5',
    power: '80',
    accuracy: '100%',
    gen: 8,
  },
];

export const MOVEMAP = new Map(MOVES.map((poke) => [poke.id, poke]));

export default MOVES;
